<template>
  <div class="group-booking">
    <lazy-pu-popover>
      <template #trigger>
        <div class="group-booking-popover-trigger">
          <img src="@/assets/images/info.svg" alt="" width="25" height="25" />
          <translate>Booking as a group?</translate>
        </div>
      </template>
      <template #content>
        <div class="group-booking-popover-contents">
          <translate tag="p"> To generate better results: </translate>
          <ul>
            <translate tag="li">
              Choose the 'Multiple units per pitch' filter in the search
              results.
            </translate>
            <translate tag="li">
              Break your booking down into smaller groups and book multiple
              pitches.
            </translate>
            <translate tag="li">
              Click the button 'Make another booking like this' on the
              confirmation page to easily rebook.
            </translate>
            <translate tag="li">
              Ask to be sited together in the 'Special requests' box on the
              booking form.
            </translate>
          </ul>
          <translate tag="p">
            You can also try filtering your search by group type and by sites
            allowing multiple tents/caravans/motorhomes per pitch.
          </translate>
        </div>
      </template>
    </lazy-pu-popover>
  </div>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class GroupBooking extends Vue {}

export default toNative(GroupBooking)
</script>

<style scoped>
.group-booking {
  margin: 1em 0;
  text-align: center;
}

.group-booking-popover-trigger {
  display: flex;
  align-items: center;
}

.group-booking-popover-trigger span {
  font-size: var(--body);
  color: #97a1a5;
}

.group-booking-popover-trigger img {
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  margin-right: 0.35em;
  opacity: 0.2;
}

.group-booking-popover-contents {
  text-align: left;
}

.group-booking-popover-contents ul {
  padding-top: 0.5em;
}

.group-booking-popover-contents li {
  list-style: disc;
  margin-left: 1.5em;
  padding-bottom: 0.5em;
}
</style>
